module.exports = __webpack_public_path__ + "img/07-defaul.da633e95.png";